module.exports = __webpack_public_path__ + "66311e27578fc551db3ee0eef8b94e19.jpg";